import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataBoolean,
  HeaderAlignment,
} from "pbas-vue-components";
import { translate2 } from "../trans2";

const headers = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "Name",
    type: new ODataString("Translations[]/Name",{
      getString: (item) => {
        return translate2(item, "Name");
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    sortable: false
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Html",
    type: new ODataString("Translations[]/Html",{
      getString: (item) => {
        const trans = translate2(item, "Html");
        return trans.length>100?trans.substring(0,100)+"...":trans;
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    sortable: false,
    version: 2
  }),
  new ODataHeader({
    title: "PlanId",
    type: new ODataString("PlanId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.coverageitems.content_categories",
    type: new ODataString("CoverageTileItemCoverageTiles[]/CoverageTile/Translations[]/Name", {
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
      getString: (item) => {
        return item.CoverageTileItemCoverageTiles.map(o=>translate2(o.CoverageTile, "Name")).join(", ")
      }
    }),
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    sortable: false,
    version:1
  }),
  new ODataHeader({
    type: new ODataString("CoverageTileItemCoverageTiles[]/CoverageTile/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("CoverageTileItemCoverageTiles[]/CoverageTile/Translations[]/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  // new ODataHeader({
  //   type: new ODataString("JsonCoverageIds"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    title: "globals.class",
    type: new ODataString("ClassCoverageTileItem/Class"),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    version: 1
  }),
  new ODataHeader({
    type: new ODataString("AllowedGuest"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
export default headers;
